import { Box, Grid, Typography } from '@mui/material'
import ActivityLogList from '../../../components/activityTracking'
import ActivityFilters from '../../../components/activityTracking/ActivityFilters'
import { useState } from 'react'

export default function ActivityPage() {
  const [page, setPage] = useState(1)

  return (
    <>
      <Grid container justifyContent="space-between" mt={2} spacing={3}>
        <Grid item xs={12} md={4}>
          <Typography fontSize="24px" fontWeight={400}>
            Activity Filters
          </Typography>
          <Box mt={4}>
            <ActivityFilters setPage={setPage} />
          </Box>
        </Grid>

        <Grid item xs={12} md={8}>
          <Typography fontSize="24px" fontWeight={400}>
            Timeline
          </Typography>
          <Box mt={4}>
            <ActivityLogList page={page} setPage={setPage} />
          </Box>
        </Grid>
      </Grid>
    </>
  )
}
